import styled from 'styled-components';

export const IconArea = styled.div`
  display: flex;
  align-items: center;
`;

export const IconAreaCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CircleNFEStatus = styled.div<{ backgroundColor: string }>`
  width: 12px;
  height: 12px;
  border-radius: 16px;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;

export const IdleFeeContainer = styled.div`
  padding-left: 20px;
  padding-top: 12px;
  padding-bottom: 8px;
  max-width: 300px;

  .idleTitleInfo {
    margin-bottom: 4px;
  }
`;

export const IdleFeeLabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 4px;
`;

export const IdleFeeTitle = styled.p`
  margin-bottom: 0px;
  margin-right: 4px;
  font-weight: 600;
  font-size: 12px;
`;

export const IdleFeeValue = styled.p`
  margin-bottom: 0px;
  font-size: 12px;
`;
